import classNames from 'classnames'
import { FormItem } from 'components'
import { countries } from 'i18n-iso-countries/langs/de.json'
import messages from 'i18n/messages'
import flowRight from 'lodash/flowRight'
import { disableCustomerDeliveryAddr, enableCustomerDeliveryAddr, makeSelectCustomer, updateCustomerAddrIndexAttr, updateCustomerAttr, setCustomerFromLS } from 'logic/customers'
import { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import Select from 'react-select'
import { Col, FormGroup, FormText, Input, Label, Row } from 'reactstrap'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'

export const atsxRegex = '[A-Z]{3}[0-9]{4}[MF]{1}'

const countryOpts = Object.keys(countries).map(ccode => ({ value: ccode, label: countries[ccode] }));

class ContactForm extends Component {

  static async getInitialProps(ctx) {
    const { id } = ctx.query;
    ctx.store.dispatch(fetchOrderById(id))

    return { pageProps: { id } };
  }

  componentDidMount() {
    this.props.actions.setCustomerFromLS()
  }

  handleChange = (key, value) =>
    this.props.actions.updateCustomerAttr(
      key,
      value,
    )

  handleChangeAddrIndex = index =>
    (key, value) =>
      this.props.actions.updateCustomerAddrIndexAttr(
        index,
        key,
        value,
      )

  handleChangeAddrIndexCountry = index =>
    val =>
      this.props.actions.updateCustomerAddrIndexAttr(
        index,
        'country_code',
        val.value,
      )

  handleToggleRegisterNew = () =>
    this.props.actions.updateCustomerAttr(
      'register_new',
      !this.props.customer.register_new,
    )

  handleToggleAcceptTerms = () =>
    this.props.actions.updateCustomerAttr(
      'accept_terms',
      !this.props.customer.accept_terms,
    )

  handleChangeCountry = val =>
    this.props.actions.updateCustomerAttr(
      'country_code',
      val.value,
    )

  handleToggleDeliveryAddress = () =>
    this.props.customer.addresses.length > 0
      ? this.props.actions.disableCustomerDeliveryAddr()
      : this.props.actions.enableCustomerDeliveryAddr()

  renderCustomerDeliveryAddr = (contact, addr, index) => (
    <div key={`addr-${index}`}>
      <hr />
      <h3><FormattedMessage {...messages.deliveryAddr} /></h3>
      <FormItem name="street" onChange={this.handleChangeAddrIndex(index)} obj={addr} required />
      <Row>
        <Col lg={3}>
          <FormItem name="postcode" onChange={this.handleChangeAddrIndex(index)} obj={addr} required />
        </Col>
        <Col lg={9}>
          <FormItem name="city" onChange={this.handleChangeAddrIndex(index)} obj={addr} required />
        </Col>
      </Row>
      <FormGroup>
        <Label>
          <FormattedMessage {...messages.country} />
        </Label>
        <Select
          className="primary"
          id="delivery-addr-select-country"
          optionClassName="needsclick"
          name="country_code"
          required
          value={countryOpts.find(o => o.value === (addr.country_code))}
          onChange={this.handleChangeAddrIndexCountry(index)}
          options={countryOpts}
        />
      </FormGroup>
    </div>
  )

  render() {
    const { customer } = this.props;

    return (
      <div className={classNames('contact-form tt-checkout')}>
        <div className="section-header">
          <h2><FormattedMessage {...messages.contactData} /></h2>
          <div className="agreed-terms">
            {customer.email}
          </div>
        </div>
        <div className="collapsed-content">
          <Row>
            <Col lg={7}>
              <FormItem name="email" onChange={this.handleChange} obj={customer} required />
            </Col>
            <Col lg={5}>
              <FormItem
                name="meta.atsx_num"
                label="ATSX #"
                onChange={this.handleChange}
                obj={customer}
                required
                pattern={atsxRegex}
                placeholder="e.g.: AUT1234F"
              />
            </Col>
          </Row>
          <p>
            <FormText>
              <FormattedMessage {...messages.explainRequiredFields} values={{ sup: (...chunks) => <sup key="ttt">{chunks}</sup> }} />
            </FormText>
          </p>
          <hr />
          <h3><FormattedMessage {...messages.billingAddr} /></h3>
          <Row>
            <Col xs={12} sm={6}>
              <FormItem
                name="firstname"
                onChange={this.handleChange}
                obj={customer}
              />
            </Col>
            <Col xs={12} sm={6}>
              <FormItem name="lastname" onChange={this.handleChange} obj={customer} />
            </Col>
          </Row>
          <FormItem name="street" onChange={this.handleChange} obj={customer} />
          <Row>
            <Col lg={3}>
              <FormItem name="postcode" onChange={this.handleChange} obj={customer} />
            </Col>
            <Col lg={9}>
              <FormItem name="city" onChange={this.handleChange} obj={customer} />
            </Col>
          </Row>
          <FormGroup>
            <Label>
              <FormattedMessage {...messages.country} />
            </Label>
            <Select
              className="primary"
              instanceId="billing-addr-select-country"
              optionClassName="needsclick"
              name="country_code"
              value={countryOpts.find(o => o.value === customer.country_code)}
              onChange={this.handleChangeCountry}
              options={countryOpts}
            />
          </FormGroup>
        </div>
      </div>
    )
  }

}

const mapStateToProps = createStructuredSelector({
  customer: makeSelectCustomer(),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    updateCustomerAttr,
    enableCustomerDeliveryAddr,
    disableCustomerDeliveryAddr,
    setCustomerFromLS,
    updateCustomerAddrIndexAttr,
  }, dispatch)
});

const enhance = flowRight(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)

export default enhance(ContactForm);
